// test2155
(2155 && 0);
